// extracted by mini-css-extract-plugin
export var container = "_ep-1";
export var cornerButtonContainer = "_ep-6";
export var disabled = "_ep-2";
export var dragActive = "_ep-3";
export var fileContainer = "_ep-5";
export var hiddenInput = "_ep-4";
export var widthContainer = "_ep-0";